module.exports = __webpack_public_path__ + "static/media/SFProDisplay-Regular.89a0dda9.woff";


//////////////////
// WEBPACK FOOTER
// ./src/themes/fonts/SFProDisplay-Regular.woff
// module id = 330
// module chunks = 1